<script>
    import FilterButton from "./FilterButton.svelte";
    import MoreButton from "./MoreButton.svelte";
    import { createEventDispatcher } from "svelte";

    export let selectedFilters = [];
    export let wrap = false;
    export let disableMoreButton = false;
    export let showMore = false;
    export let filters = [];

    let dispatch = createEventDispatcher();

    let mainFilters = filters.filter((filter) => filter.isMainTag);
</script>

<div class="button-row" class:wrap>
    {#each selectedFilters.filter((e) => !e.isMainTag) as filter}
        <FilterButton
            {filter}
            on:click={() => dispatch("toggleFilter", filter.id)}
            selected={selectedFilters.find((e) => e.id === filter.id)}
            showCross
        />
    {/each}

    {#each mainFilters as filter}
        <FilterButton
            {filter}
            on:click={() => dispatch("toggleFilter", filter.id)}
            selected={selectedFilters.find((e) => e.id === filter.id)}
        />
    {/each}
    {#if !disableMoreButton}
        <div class="divider-v button-divider mobile-only" />
        <div class="mobile-only">
            <MoreButton
                on:click={() => dispatch("moreClicked")}
                showsMore={showMore}
            />
        </div>
    {/if}
</div>

<style>
    .button-divider {
        height: auto;
        margin: 0 4px;
    }

    .mobile-only {
        display: block;
    }

    .wrap {
        flex-wrap: wrap;
    }

    .button-row {
        display: flex;
        flex-direction: row;
        margin: 16px -16px 16px -16px;
        padding: 0 16px;
        overflow-x: auto;
        overflow-y: hidden;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .button-row::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 1440px) {
        .button-row {
            flex-wrap: wrap;
        }

        .mobile-only {
            display: none;
        }
    }
</style>
